export default function printError (err) {
  if (Array.isArray(err)) {
    if (Array.isArray(err[0])) {
      return this.printError(err[0])
    } else if (typeof err[0] === 'object') {
      /* for(var key in err[0]){
        if (err.hasOwnProperty(key)){

        }
      } */
    }
    return err[0]
  }
  return err
}

export function systemError (response) {
  console.log('XX', response)
  if (response.response) {
    response = response.response
  }
  let err = response.data.message || response.data.errors || response.data.error || response.data || response.message || response.detail || response.title
  if (Array.isArray(err)) {
    return err
  }
  return [err]
}

export function errorToString (response, separator = ".\r\n ") {
  let err = systemError(response)
  let errors = valuesOfArray(err);
  console.log(errors)
  return errors.join(separator)
}

export function valuesOfArray (a) {
  let values = []
  if (Array.isArray(a)) {
    a.forEach((a2) => {
      if (typeof a2 === 'object') {
        let v = Object.values(a2)
        if(Array.isArray(v) || typeof v === 'object') {
          v = valuesOfArray(v)
        }
        values = values.concat(v)
      } else {
        let p = valuesOfArray(a2)
        values = values.concat(p)
      }
    })
  } else {
    if (typeof a === 'object') {
      values = values.concat(Object.values(a))
    } else {
      values.push(a)
    }
  }
  return values
}
